module.exports = __webpack_public_path__ + "assets/img/nh2.014c12ad.jpg";